import css from 'styled-jsx/css';

export default css`.banner {
  height: 100vh; }
  @media only screen and (max-width: 500px) {
    .banner {
      min-height: 750px;
      position: relative; } }
  .banner .PCBanner {
    width: 100%;
    height: 100%;
    margin-top: -110px;
    overflow: hidden; }
    .banner .PCBanner img {
      height: 644px;
      position: relative;
      left: 604px;
      z-index: 0; }
    @media only screen and (max-width: 500px) {
      .banner .PCBanner {
        display: none; } }
  .banner .text {
    left: 10%;
    width: 343px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    color: #414141; }
    @media only screen and (max-width: 500px) {
      .banner .text {
        left: 50%;
        width: auto;
        top: unset;
        bottom: 15%;
        transform: translateX(-50%);
        text-align: center; } }
    .banner .text h1 {
      font-size: 40px;
      font-weight: bold;
      line-height: 1.2;
      letter-spacing: 0.66px; }
      @media only screen and (max-width: 500px) {
        .banner .text h1 {
          font-size: 34px; } }
    .banner .text h3 {
      font-size: 20px;
      line-height: 1.6;
      letter-spacing: 0.4px;
      margin-top: 16px; }
    .banner .text p {
      font-size: 16px;
      line-height: 2.13;
      letter-spacing: 0.27px;
      margin-top: 4px; }
      @media only screen and (max-width: 500px) {
        .banner .text p {
          font-size: 14px; } }
    .banner .text .BannerBtn {
      background-color: #7d7af4;
      width: 343px;
      line-height: 56px;
      border-radius: 28px;
      color: white;
      text-align: center;
      margin-top: 32px;
      animation: bouncein 0.5s;
      cursor: pointer; }
      @media only screen and (max-width: 500px) {
        .banner .text .BannerBtn {
          width: 95vw;
          max-width: 343px; } }
      .banner .text .BannerBtn :hover {
        opacity: 0.5; }

@keyframes bouncein {
  0% {
    transform: scale(0); }
  50% {
    transform: scale(1.2); }
  100% {
    transform: scale(1); } }
  .banner .MOBBanner {
    display: none;
    margin-top: -90px; }
    @media only screen and (max-width: 500px) {
      .banner .MOBBanner {
        display: block; } }
    .banner .MOBBanner img {
      width: 100%; }
`